import React from 'react';
import process_1 from '../../../assets/images/process/process-1.png';
import process_2 from '../../../assets/images/svg/process/people.svg';
import process_3 from '../../../assets/images/svg/process/strategies.svg';
import process_4 from '../../../assets/images/svg/process/analysis.svg';
import process_5 from '../../../assets/images/svg/process/cooperation.svg';
import process_6 from '../../../assets/images/svg/process/statistics.svg';

const processData = [
    {
        id: 1,
        title: 'People',
        description: 'We guarantee to provide affordable business consulting solutions that help you reduce',
        icon: process_2,
        delay: '0ms',
    },
    {
        id: 2,
        title: 'Strategies',
        description: 'Our solutions are scalable and can grow with your business, ensuring you get the most.',
        icon: process_3,
        delay: '400ms',
    },
    {
        id: 3,
        title: 'Analysis',
        description: 'We specialize in serving specific industries, such as healthcare, finance, or manufacturing.',
        icon: process_4,
        delay: '600ms',
    },
    {
        id: 4,
        title: 'Cooperation',
        description: 'We embarked on our journey with a distinct approach. Instead of adhering.',
        icon: process_5,
        delay: '800ms',
    },
    {
        id: 5,
        title: 'Statistics',
        description: 'We guarantee to provide affordable business consulting solutions that help you reduce.',
        icon: process_6,
        delay: '1000ms',
    },
];

const Process = () => {
    return (
        <>
            <div className="process-section-one">
                <div className="container">
                    <div className="heading-box">
                        <span className="sub-title animate fadeInUp wow" data-wow-duration="1500ms">
                            Process
                        </span>
                        <h2 className="heading-title animate fadeInUp wow" data-wow-duration="1500ms" data-wow-delay="200ms">
                            How does it Work?
                        </h2>
                    </div>
                    <div className="process-inner-one">
                        {processData.map((process) => (
                            <div
                                key={process.id}
                                className="process-box-one animate fadeInRight wow"
                                data-wow-duration="2000ms"
                                data-wow-delay={process.delay}
                            >
                                <img src={process_1} alt="image" />
                                <div className="process-icon-one">
                                    <img src={process.icon} alt="icon" />
                                </div>
                                <h4>
                                    <span>{process.id < 10 ? `0${process.id}` : process.id} . </span>
                                    {process.title}
                                </h4>
                                <p className="lead">{process.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Process;